module.exports = __webpack_public_path__ + "img/RS.226cb436.png";